import { render, staticRenderFns } from "./ProfileStats.vue?vue&type=template&id=115f21b4&scoped=true"
import script from "./ProfileStats.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileStats.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileStats.vue?vue&type=style&index=0&id=115f21b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f21b4",
  null
  
)

export default component.exports